//@flow
import React from 'react';
import {Container} from 'flux/utils';
import ModalActions from '../../Actions/modal';
import Footer from '../../Footer/components/Footer.react';
import OfficeFooter from '../../Office/components/OfficeFooter.react';
// NOTE: using new header component but importing as `Header`
// See notes in `HeaderNew` component
import Header from '../../Header/components/HeaderNew.react';
import CartPreviewWrapper from '../../Cart/components/CartPreviewWrapper.react';
import LoginModal from '../../LoginModal/components/LoginModal.react';
import CreateAccountModal from '../../CreateAccount/components/CreateAccountModal.react';
import CreateAccountModalStore from '../../Stores/CreateAccountModal/createAccountModal';
import ResetEmailSentModal from '../../LoginModal/components/ResetEmailSentModal.react';
import MagicLinkSentModal from '../../LoginModal/components/MagicLinkSentModal.react';
import MagicLinkModal from '../../LoginModal/components/MagicLinkModal.react';
import ScrollListener from './ScrollListener.react';
import SessionStore from '../../Stores/Session/session';
import CategoriesStore from '../../Stores/MemberCategories/categories';
import ShellStore from '../../Stores/Shell/shell';
import CustomerStore from '../../Stores/Customer/customer';
import ProductsStore from '../../Stores/Products/products';
import QuoteStore from '../../Stores/Quote';
import MembershipStore from '../../Stores/Membership/membershipStore';
import MktgStore from '../../Stores/Mktg/mktgStore';
import OrderStore from '../../Stores/Order/orderSingleton';
import UrlData from '../../Utils/url-data';
import HelloBarStore from '../../Stores/HelloBar/helloBarStore';
import FiltersStore from '../../Stores/Filters/filtersStore';
import StockStore from '../../Stores/Stock/stock';
import Constants from '../../constants';
import SetPasswordNotification from '../../GhostAccount/components/SetPasswordNotification.react';
import AmazonCheckoutErrorModal from '../../AmazonPay/components/AmazonCheckoutErrorModal.react';
import ChatInfoModal from '../../Chat/components/ChatInfoModal.react';
import { Helmet } from 'react-helmet';
import MsrpNonMembModal from '../../Modal/components/MsrpPopModal.react';
import SearchModal from '../../../components/SearchModal.react';
import PromoNotification from '../../Notification/components/PromoNotification.react';
import StoreCreditNotification from '../../Notification/components/StoreCreditNotification.react';
import CartNotification from '../../Cart/components/CartNotification.react';
import HelpButton from '../../Chat/components/HelpButton.react';
import { isIOS } from '../../Utils/device';
import GiftUtils from '../../Utils/gifts';

import type MembershipModel from '../../Stores/Membership/membershipModel';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type OrderCollection from '../../Stores/Order/orderCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type { HelloBarConfig } from '../../Stores/Mktg/mktgModelInterfaces';

type Props = {
  children?:any,
  disableCartPreview?:boolean,
  simpleHeader?:boolean,
  inCheckout?:boolean,
  inCheckoutSuccess?:boolean,
  unstickMobileHeader?:boolean,
  hideFooter?:boolean,
  helloBar?:boolean,
  hideHeader?:boolean,
  pageTitle?:string,
  metaDescription?:string,
  className?:string,
  isOffice?:boolean,
};

type State = {
  quote:QuoteModel,
  quoteItems:QuoteItemsCollection,
  quoteTotals:QuoteTotalsModel,
  activeSubQuote:QuoteModel,
  products:ProductsCollection,
  categories:CategoriesCollection,
  membership:MembershipModel,
  customer:CustomerModel,
  membershipPlan:MembershipPlanModel,
  orders:OrderCollection,
  inUS:boolean,
  loggedIn:boolean,
  isMenuOpen:boolean,
  showCategories:boolean,
  cartPreviewOpen:boolean,
  unauthorized:boolean,
  createAccountModalIsOpen:boolean,
  resetEmail:?string,
  helloBarConfig:HelloBarConfig,
  hasSub:boolean,
  magicLinkEmail:?string,
  stock:StockCollection,
};

class ShellApp extends React.Component<Props, State> {
  //detect IOS so can apply a class which will raise buttons so they're visible for apple
  _IOS:boolean = isIOS();

  static defaultProps = {
    pageTitle: 'NatureBox',
  }

  static getStores() {
    return [
      CreateAccountModalStore,
      SessionStore,
      CategoriesStore,
      CustomerStore,
      QuoteStore,
      ShellStore,
      ProductsStore,
      MembershipStore,
      HelloBarStore,
      FiltersStore,
      StockStore,
      MktgStore,
    ];
  }

  static calculateState(prevState:State, props:Props):State {
    let isMenuOpen = false;
    const loggedIn = SessionStore.isLoggedIn();
    const categories = CategoriesStore.getCategories();
    const quote = QuoteStore.getQuote();
    const activeSubQuote = QuoteStore.getSubActiveQuote();
    const products = ProductsStore.getProducts();
    const quoteItems = QuoteStore.getQuoteItems(quote.getId());
    const quoteTotals = QuoteStore.getQuoteTotals(quote.getId(), {
      products,
      quoteItems,
    });
    const inUS = CustomerStore.inUS(quote);
    const membership = MembershipStore.getMembership();
    const newMemberPlanCode = quote.getNewMembershipPlanCode();
    const showCategories = !props.inCheckout;
    if (prevState) {
      if (prevState.isMenuOpen) {
        isMenuOpen = !loggedIn;
      }
    }
    const helloBarConfig = MktgStore.getHelloBarConfig();
    //if user has a gift box, force them into MSRP test behavior
    const customer =  CustomerStore.getCustomer();

    return {
      quote,
      quoteItems,
      quoteTotals,
      activeSubQuote,
      loggedIn,
      isMenuOpen,
      showCategories,
      inUS,
      membership,
      products,
      categories,
      customer,
      cartPreviewOpen: ShellStore.cartPreviewOpen(),
      unauthorized: SessionStore.isLoginError(),
      createAccountModalIsOpen: CreateAccountModalStore.isOpen(),
      resetEmail: CustomerStore.getResetEmail(),
      magicLinkEmail: CustomerStore.getMagicLinkEmail(),
      orders: OrderStore.getOrders(),
      helloBarConfig,
      membershipPlan: MembershipStore.getMembershipPlan(newMemberPlanCode),
      hasSub: Boolean(QuoteStore.getSubActiveQuote().getId() || QuoteStore.getSubProcessingQuote().getId()),
      mobileFiltersOpen: FiltersStore.getMobileFiltersOpen(),
      stock: StockStore.getStock(),
    };
  }

  componentDidMount() {
    const body:any = document.body;
    if (this._IOS && body && body.addEventListener) {
      body.addEventListener('touchstart', this._handleTouchStart);
      body.addEventListener('touchmove', this._handleTouchMove);
    }
  }

  _handleTouchStart = (e:{target:Element}) => {
    if (!this._bodyIsFrozen()) return;
    let target = e.target;

    /*
     * If a touch originates in a scrollable element and the element is scrolled all the way to the
     * top or bottom, move it toward the middle so that the touchmove can only scroll the scrollable
     * element and not the body.
     */
    while (target) {
      if (target.classList && target.classList.contains('scrollable')) {
        if (target.scrollTop === 0) {
          target.scrollTop = 1;
        } else if (target.scrollHeight === target.scrollTop + target.clientHeight) {
          target.scrollTop -= 1;
        }
        return;
      }
      target = target.parentElement;
    }
  };

  _handleTouchMove = (e:{target:Element, stopPropagation:() => void, preventDefault:() => void}) => {
    if (!this._bodyIsFrozen()) return;
    let target = e.target;

    while (target) {
      if (target.classList && target.classList.contains('scrollable')) {

        // Allow the event to bubble up and be prevented if the scrollable element is too small
        if (!(target.scrollHeight > window.innerHeight)) break;

        // Allow the event on the scrollable element but don't let it bubble up to the body
        e.stopPropagation();
        return;
      }
      target = target.parentElement;
    }

    // Prevent the event if it's not acting on a scrollable element
    e.preventDefault();
  };

  _bodyIsFrozen() {
    const body = document.body;
    return body && body.classList && body.classList.contains('frozen');
  }

  getClassName() {
    return UrlData.getPathname().replace('/', '');
  }

  handleLoginClick() {
    ModalActions.openModal(Constants.LOGIN_MODAL);
  }

  simulateWindowScroll(scrollEvent:Event) {
    window.dispatchEvent(scrollEvent);
  }

  toggleSidebar = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    });
  };

  _getTotalCartQty() {
    const quoteItems = this.state.quoteItems;
    if (!quoteItems || this.props.inCheckoutSuccess) return 0;
    return quoteItems.getTotalItemsQty();
  }

  _getIOSClass() {
    return this._IOS ? 'ios' : '';
  }

  _getActiveClass() {
    return this.state.cartPreviewOpen ? 'active' : '';
  }

  _getContentClassName() {
    const {className} = this.props;
    const classes = ['shell-content'];
    if (className) classes.push(className);
    return classes.join(' ');
  }

  _getIsOfficeRoute() {
    return this.props.isOffice;
  }

  _renderSetPasswordNotification() {
    if (this.state.customer && this.state.customer.isGuest() && !this.props.inCheckout &&
      (this.state.membership.isReturningMember() || this.props.inCheckoutSuccess)) {
      return <SetPasswordNotification />;
    }
  }

  _showGiftUI() {
    return this.state.categories.hasQuoteItemForUrlKey('m-gifts', this.state.quoteItems) ||
      GiftUtils.hasEgiftInCart(this.state.quoteItems);
  }

  _renderCartNotification() {
    if (this.state.cartPreviewOpen || this.props.inCheckout) return null;

    return (
      <CartNotification
        products={this.state.products}
        inUS={this.state.inUS}
        quoteId={this.state.quote.getId()}
        quote={this.state.quote}
        quoteItems={this.state.quoteItems}
        membership={!this.state.membership.isReturningMember()}
        customer={this.state.customer}
        activeSubQuoteId={this.state.activeSubQuote.getId()}
        categories={this.state.categories}
        stock={this.state.stock}
        membershipPlan={this.state.membershipPlan}
      />
    );
  }

  _renderHeader() {
    if (this.props.hideHeader) return null;
    return (
      <Header
        openMenu={this.toggleSidebar}
        handleLoginClick={this.handleLoginClick}
        categories={this.state.categories}
        customer={this.state.customer}
        cartQty={this._getTotalCartQty()}
        disableCartPreview={this.props.disableCartPreview || false}
        showCategories={this.state.showCategories}
        helloBarConfig={this.state.helloBarConfig}
        quoteTotals={this.state.quoteTotals}
        quoteItems={this.state.quoteItems}
        inUS={this.state.inUS}
        quote={this.state.quote}
        hasSub={this.state.hasSub}
        newMember={!this.state.membership.isReturningMember()}
        helloBar={this.props.helloBar}
        simpleHeader={this.props.simpleHeader || false}
        unstickMobile={this.props.unstickMobileHeader || false}
      />
    );
  }

  _renderFooter() {
    if (this.props.hideFooter) return <p>&nbsp;</p>;
    if (this._getIsOfficeRoute()) {
      return <OfficeFooter />;
    } else {
      return <Footer />;
    }
  }

  _renderMeta():React$Node[] {
    // Meta data that should appear on every page
    const metas = [
      {
        name: 'google-site-verification',
        content: 'k4f2sviKDDJ6_DfHYXbH1UuQuW__axfXfGqOHDUeBZQ',
      },
    ];
    // Additional meta tags only added if specified by props
    if (this.props.metaDescription) {
      metas.push({
        name: 'description',
        content: this.props.metaDescription,
      });
    }

    return metas.map((props, index) => (
      <meta {...props} key={index} />
    ));
  }

  render() {
    return (
      <div className={`${this._getIOSClass()} ${this._getActiveClass()}`}>
        <Helmet title={this.props.pageTitle}>
          {this._renderMeta()}
        </Helmet>
        <HelpButton />
        <CartPreviewWrapper
          loggedIn={this.state.loggedIn}
          customer={this.state.customer}
          handleLoginClick={this.handleLoginClick}
          isMenuOpen={this.state.isMenuOpen}
          categories={this.state.categories.getDropdownCategories()}
          mobileOnSetOpen={this.toggleSidebar}
          showCategories={this.state.showCategories}
          isCartOpen={this.state.cartPreviewOpen}
          quoteItems={this.state.quoteItems}
          quoteTotals={this.state.quoteTotals}
          products={this.state.products}
          quote={this.state.quote}
          membership={this.state.membership}
          isIOS={this._IOS}
          membershipPlan={this.state.membershipPlan}
          hasSub={this.state.hasSub}
          showGiftUI={this._showGiftUI()}
          stock={this.state.stock}
        >
          <div id="container" className={this.getClassName()} style={{WebkitOverflowScrolling: 'touch'}}>
            <ScrollListener />
            {this._renderHeader()}
            <div className={this._getContentClassName()}>
              {this.props.children}
            </div>
            {this._renderSetPasswordNotification()}
            <PromoNotification />
            <StoreCreditNotification />
            {this._renderCartNotification()}
            {this._renderFooter()}
            <LoginModal />
            <CreateAccountModal
              isOpen={this.state.createAccountModalIsOpen}
            />
            <ResetEmailSentModal
              resetEmail={this.state.resetEmail || ''}
            />
            <MagicLinkModal />
            <MagicLinkSentModal
              magicLinkEmail={this.state.magicLinkEmail || ''}
            />
            <AmazonCheckoutErrorModal
              membership={this.state.membership}
            />
            <ChatInfoModal />
            <MsrpNonMembModal
              membershipPlan={this.state.membershipPlan}
            />
            <SearchModal />
          </div>
        </CartPreviewWrapper>
      </div>
    );
  }
}

export default Container.create(ShellApp, { withProps: true });
